import { observer, inject } from 'mobx-react'
import { Route, Routes } from 'react-router'
import CancellationPolicy from './CancellationPolicy'

import InitialPaymentPage from './InitialPaymentPage'
import SetupPayment from './SetupPayment'
import Page from './style'

function RetailPayment() {
  return (
    <Page>
      <Routes>
        <Route path='/setup-payment' element={<SetupPayment />} />
        <Route path='/cancellation-policy' element={<CancellationPolicy />} />
        <Route path='/' element={<InitialPaymentPage />} />
      </Routes>
    </Page>
  )
}

export default inject('store')(observer(RetailPayment))
